// extracted by css-extract-rspack-plugin
export default {"cls1":"download_button_search_redesign-cls1_R5_","cls2":"download_button_search_redesign-cls2_D20 download_button_search_redesign-cls1_R5_"};